import axios from 'axios';

const API_URL = 'http://137.74.92.81:3098';

export interface IUser {
    id: number;
    name: string;
    country: string;
    windowsId: string;
}

export async function getProfile(userId: string): Promise<IUser> {
    const url = API_URL + '/getUser';
    const data = await axios.post(url, { windowsId: userId });
    return data.data as IUser;
}

export interface IChangeName {
    success: boolean;
    exists?: boolean;
}

export async function saveProfileName(uid: number, newUserName: string): Promise<IChangeName> {
    const url = API_URL + '/changeUserName';
    const data = await axios.post(url, { userId: uid, newUserName });
    return data.data as IChangeName;
}